export default "__VITE_ASSET__BRCwDF2x__"